import styled from "styled-components";
import { useState } from "react";
import StudentAssignListView from "./StudentAssignListView";
import LessonAssignListView from "./LessonAssignListView";
import { hw, scrollbar } from "features/homework/homeworkUi";

const LessonAssign = () => {
    const [clickedLesson, setClickedLesson] = useState("");
    return (
        <Body>
            <LessonAssignListView clickedItem={clickedLesson} setClickedItem={setClickedLesson} />
            {clickedLesson ? (
                <StudentAssignListView clickedLesson={clickedLesson} />
            ) : (
                <EmptyPanel>
                    <EmptyTitle>학급을 선택하세요</EmptyTitle>
                    <EmptyText>왼쪽에서 학급을 고르면 배정할 원생이 표시됩니다.</EmptyText>
                </EmptyPanel>
            )}
        </Body>
    );
};

const Body = styled.div`
    display: grid;
    grid-template-columns: minmax(280px, 0.9fr) minmax(0, 1.1fr);
    gap: 16px;
    flex: 1;
    min-height: 0;
    width: 100%;

    @media (max-width: 960px) {
        grid-template-columns: minmax(0, 1fr);
        overflow: auto;
        ${scrollbar}
    }
`;

const EmptyPanel = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 240px;
    padding: 24px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 16px;
    box-shadow: ${hw.shadow};
    text-align: center;
`;

const EmptyTitle = styled.div`
    font-size: 16px;
    font-weight: 700;
    color: ${hw.text};
`;

const EmptyText = styled.div`
    font-size: 13px;
    color: ${hw.textMuted};
    line-height: 1.5;
`;

export default LessonAssign;
